import React from 'react';

import { teamMeta } from '../../constants';
import TaskDetail from '../TaskDetail';
import TaskRow from '../TaskRow';
import styles from './TasksView.module.scss';

const TasksView = ({
  activeTeam,
  setActiveTeam,
  statusFilter,
  setStatusFilter,
  stats,
  filtered,
  selectedTask,
  setSelectedTask,
}) => {
  const safeStats = stats ?? { total: 0, member: 0, ops: 0, clinical: 0, critical: 0, blocked: 0 };
  const safeFiltered = filtered ?? [];
  const safeActiveTeam = activeTeam || 'all';
  const safeStatusFilter = statusFilter || 'open';

  const teamTabs = [
    { key: 'all', label: 'All', count: safeStats.total },
    { key: 'member', label: 'Member', count: safeStats.member },
    { key: 'ops', label: 'Ops', count: safeStats.ops },
    { key: 'clinical', label: 'Clinical', count: safeStats.clinical },
  ];

  const statusTabs = [
    { key: 'open', label: 'Open' },
    { key: 'critical', label: `Critical ${safeStats.critical}` },
    { key: 'blocked', label: `Blocked ${safeStats.blocked}` },
  ];

  return (
    <>
      <div className={styles.filters}>
        <div className={styles.filterGroup}>
          {teamTabs.map((team) => (
            <button
              key={team.key}
              type="button"
              onClick={() => setActiveTeam(team.key)}
              className={`${styles.filterButton} ${
                safeActiveTeam === team.key ? styles.filterActive : ''
              }`}
            >
              {team.label}
              <span className={styles.filterCount}>{team.count}</span>
            </button>
          ))}
        </div>
        <div className={styles.filterDivider} />
        <div className={styles.filterGroup}>
          {statusTabs.map((status) => (
            <button
              key={status.key}
              type="button"
              onClick={() => setStatusFilter(status.key)}
              className={`${styles.filterButton} ${
                safeStatusFilter === status.key ? styles.filterActive : ''
              }`}
            >
              {status.label}
            </button>
          ))}
        </div>
      </div>

      <div className={`${styles.layout} ${selectedTask ? styles.layoutWithDetail : ''}`}>
        <div className={styles.listCard}>
          <div className={styles.tableHeader}>
            <span />
            <span className={styles.headerCell}>Task</span>
            <span className={styles.headerCell}>Status</span>
            <span className={styles.headerCell}>Pathway</span>
            <span className={`${styles.headerCell} ${styles.headerDue}`}>Due</span>
          </div>

          {safeActiveTeam === 'all'
            ? ['member', 'ops', 'clinical'].map((teamKey) => {
                const teamTasks = safeFiltered.filter((task) => task.team === teamKey);
                if (!teamTasks.length) return null;

                const team = teamMeta[teamKey];
                return (
                  <div key={teamKey}>
                    <div className={styles.teamHeader}>
                      <span className={styles.teamLabel}>
                        {team?.icon} {team?.label || teamKey}
                      </span>
                      <span className={styles.teamCount}>{teamTasks.length}</span>
                    </div>
                    {teamTasks.map((task) => (
                      <TaskRow
                        key={task.id}
                        task={task}
                        selected={selectedTask?.id === task.id}
                        onSelect={setSelectedTask}
                      />
                    ))}
                  </div>
                );
              })
            : safeFiltered.map((task) => (
                <TaskRow
                  key={task.id}
                  task={task}
                  selected={selectedTask?.id === task.id}
                  onSelect={setSelectedTask}
                />
              ))}

          {!safeFiltered.length && <div className={styles.emptyState}>No tasks match filters</div>}
        </div>

        {selectedTask && (
          <div className={styles.detailPanel}>
            <TaskDetail task={selectedTask} onClose={() => setSelectedTask(null)} />
          </div>
        )}
      </div>
    </>
  );
};

export default TasksView;
